import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getTotalNumOfAnalystics = () => async (dispatch) => {
  dispatch({ type: "SHOW_NUM_ANALYSTICS_LOADING" });
  try {
    const { data } = await auction.get(`/profile/read/analytics`);
    dispatch({ type: "NUM_ANALYSTICS_DATA", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_NUM_ANALYSTICS_LOADDED" });
  }
};

export const getTranscationAmountAnalystics = () => async (dispatch) => {
  dispatch({ type: "SHOW_TRANSCATION_ANALYSTICS_LOADING" });
  try {
    const { data } = await auction.get(`/profile/read/transactions-analytics`);
    dispatch({ type: "TRANSCATION_ANALYSTICS_DATA", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_TRANSCATION_ANALYSTICS_LOADDED" });
  }
};

export const getCreateAuctionAnalystics = () => async (dispatch) => {
  dispatch({ type: "SHOW_CREATEAUCTION_ANALYSTICS_LOADING" });
  try {
    const { data } = await auction.get(
      `/profile/read/created-auction-analytics`
    );
    dispatch({ type: "CREATEAUCTION_ANALYSTICS_DATA", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_CREATEAUCTION_ANALYSTICS_LOADDED" });
  }
};
